import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#1d1c33 !important",
    },
    row: {
        display: "flex !important",
        alignItems: "center !important",
        backgroundColor: "#f1f3f7 !important",
        borderRadius: '4px !important',
        padding: "11.3px 12px !important",
        marginBottom: '1px !important',
    },
    left: {
        width: '80px !important',
        marginRight: '12px !important',
    },
    middle: {
        flex: '1px !important',
        marginRight: '12px !important',
    },
    right: {
        width: '24px !important',
    },
}));

export default function ContactListSkeleton() {
    const classes = useStyles();

    const rows = Array.from({ length: 5 });

    return (
        <div className={classes.root}>
            {rows.map((_, i) => (
                <div key={i} className={classes.row}>
                    <div className={classes.left}>
                        <Skeleton variant="text" width="100%" height={20} />
                    </div>
                    <div className={classes.middle}>
                        <Skeleton variant="text" width="80%" height={20} />
                    </div>
                    <div className={classes.right}>
                        <Skeleton variant="circle" width={20} height={20} />
                    </div>
                </div>
            ))}
        </div>
    );
}
